







import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { isToday, isYesterday } from '@/helpers/date-helper';

@Component
export default class TimeAgo extends Vue {
	@Prop(String) date: string;

	get _date() {
		return new Date(this.date);
	}

	get isToday() {
		return isToday(this._date);
	}

	get isYesterday() {
		return isYesterday(this._date);
	}
}
